
import BannerContainer from '~/components/child/banner/BannerContainer.vue';
import TagContainer from '~/components/child/tag/TagContainer.vue';
import RecipeContainer from '~/components/child/recipe/RecipeContainer.vue';
import BrowseContainer from '~/components/child/browse/BrowseContainer.vue';
import ArticleChannelContainer from '~/components/child/article/ArticleChannelContainer.vue';
import BloggerRankingChannel from '~/components/child/blogger/BloggerRankingChannel.vue';
import ArticleHotContainer from '~/components/child/article/ArticleHotContainer.vue';
import ArticleHotBeautyContainer from '~/components/child/article/ArticleHotBeautyContainer.vue';
import ProductRanking from '~/components/child/product/ProductRanking.vue';
import ProductInfo from '~/components/child/product/ProductInfo.vue';
import StyleMeArticleContainer from '~/components/child/article/StyleMeArticleContainer.vue';
export default {
    name: "beauty",
    components: { BannerContainer, TagContainer, RecipeContainer, BrowseContainer, ArticleChannelContainer, BloggerRankingChannel, ArticleHotContainer, ArticleHotBeautyContainer, ProductRanking, ProductInfo, StyleMeArticleContainer },
    head() {
        return {
            title: '美妝-PIXNET痞客邦',
            meta: [
                { hid: 'description', name: 'description', content: '痞客邦美妝匯集優秀美妝創作者，他們在彩妝教學、護膚分享、美妝評測等領域有豐富的經驗。這裡提供最新潮流趨勢，激發你的創作靈感。無論你是美妝新手還是專業人士，都能在這個充滿熱情和創意的社群中找到屬於自己的位置。加入我們，探索無限美妝可能性，與全球美妝愛好者交流，一同成長！' },
                { hid: 'og:description', name: 'og:description', property: 'og:description', content: '痞客邦美妝匯集優秀美妝創作者，他們在彩妝教學、護膚分享、美妝評測等領域有豐富的經驗。這裡提供最新潮流趨勢，激發你的創作靈感。無論你是美妝新手還是專業人士，都能在這個充滿熱情和創意的社群中找到屬於自己的位置。加入我們，探索無限美妝可能性，與全球美妝愛好者交流，一同成長！' },
                { hid: 'twitter:description', name: 'twitter:description', property: 'twitter:description', content: '痞客邦美妝匯集優秀美妝創作者，他們在彩妝教學、護膚分享、美妝評測等領域有豐富的經驗。這裡提供最新潮流趨勢，激發你的創作靈感。無論你是美妝新手還是專業人士，都能在這個充滿熱情和創意的社群中找到屬於自己的位置。加入我們，探索無限美妝可能性，與全球美妝愛好者交流，一同成長！' },
                { hid: 'keywords', name: 'keywords', content: '彩妝教學、護膚程序、自然有機美妝、K-Beauty、眼妝技巧、唇妝潮流、高光修容、眉妝技巧、長效唇彩、粉底推薦、美妝評測、美妝收藏、彩妝達人、化妝品新品、美妝追蹤、美妝博主、面膜推薦、美妝技巧、美甲設計、彩妝趨勢' },
                { hid: 'og:title', name: 'og:title', property: 'og:title', content: "美妝-PIXNET痞客邦"},
                { property: 'og:image', property: 'og:image', content: "https://www.pixnet.net/img/public/og/img_beauty_og.png"},
                { property: 'og:image:secure_url', property: 'og:image:secure_url', content: "https://www.pixnet.net/img/public/og/img_beauty_og.png"},
                { property: 'twitter:image', property: 'twitter:image', content: "https://www.pixnet.net/img/public/og/img_beauty_og.png"},
                { property: 'image', name: 'image', itemprop: 'image', content: "https://www.pixnet.net/img/public/og/img_beauty_og.png"},
            ],
            link: [
                { rel: 'canonical', href: 'https://www.pixnet.net/channel/beauty', key: "canonical"}
            ]
        }
    },
    jsonld() {
        return {
            "@context": " https://schema.org/",
            "@graph": [
                {
                    "@context":"https://schema.org",
                    "@type":"Organization",
                    "url":"https://www.pixnet.net",
                    "logo":"https://www.pixnet.net/img/public/og/img_beauty_og.png",
                    "name":"痞客邦",
                    "@id":"https://www.pixnet.net/#organization",
                    "description":"痞客邦美妝匯集優秀美妝創作者，他們在彩妝教學、護膚分享、美妝評測等領域有豐富的經驗。這裡提供最新潮流趨勢，激發你的創作靈感。無論你是美妝新手還是專業人士，都能在這個充滿熱情和創意的社群中找到屬於自己的位置。加入我們，探索無限美妝可能性，與全球美妝愛好者交流，一同成長！",
                    "address":"",
                    "brand":{
                        "@type":"Brand",
                        "logo":"https://www.pixnet.net/img/public/og/img_beauty_og.png"
                    },
                    "sameAs":"https://www.facebook.com/pixnet.net"
                },
                {
                    "@context":"https://schema.org/",
                    "@type":"BreadcrumbList",
                    "itemListElement":[
                        {
                            "@type": "ListItem",
                            "position": 1,
                            "name": "美妝-PIXNET痞客邦",
                            "item": "https://www.pixnet.net",
                            "description": "痞客邦美妝匯集優秀美妝創作者，他們在彩妝教學、護膚分享、美妝評測等領域有豐富的經驗。這裡提供最新潮流趨勢，激發你的創作靈感。無論你是美妝新手還是專業人士，都能在這個充滿熱情和創意的社群中找到屬於自己的位置。加入我們，探索無限美妝可能性，與全球美妝愛好者交流，一同成長！",
                            "keywords": "彩妝教學、護膚程序、自然有機美妝、K-Beauty、眼妝技巧、唇妝潮流、高光修容、眉妝技巧、長效唇彩、粉底推薦、美妝評測、美妝收藏、彩妝達人、化妝品新品、美妝追蹤、美妝博主、面膜推薦、美妝技巧、美甲設計、彩妝趨勢"
                        }
                    ]
                }
            ]
        }
    },
    data() {
        return {
            channel_page_id: 6,
            category_id: 23,
            showAnimation: false,
            categories: [
                { name: "美妝新訊", link: "https://styleme.pixnet.net/topics/7" },
                { name: "記者會直擊", link: "https://styleme.pixnet.net/topics/166" },
                { name: "專題報導", link: "https://styleme.pixnet.net/topics/163" },
                { name: "時尚熱話", link: "https://styleme.pixnet.net/topics/64" },
                { name: "親子熱搜", link: "https://styleme.pixnet.net/topics/1003" },
                { name: "特別企劃", link: "https://styleme.pixnet.net/topics/193" },
                { name: "站方公告", link: "https://styleme.pixnet.net/topics/205" }
            ]
        }
    },
    computed: {
        is_login() {
            return this.$store.state.login.login_status;
        },
        tab_id() {
            return this.$store.state.channel_tab.tab_id;
        },
        tab_left() {
            return this.$store.state.channel_tab.tab_highlight_style.left;
        },
        tab_width() {
            return this.$store.state.channel_tab.tab_highlight_style.width;
        },
        window_width() {
            return this.$store.state.channel_tab.window_width;
        },
        pa_page_name() {
            return '美妝';
        },
        tag_search_text() {
            return '美妝';
        },
        day_hot_article() {
            return this.$store.state.article.day_hot_article;
        },
        day_hot_article_full() {
            return this.$store.state.article.day_hot_article_full;
        }
    },
    methods: {
        countTabLeft(){
            return this.$refs.channel_tab.getBoundingClientRect().left;
        },
        initTabHighLighter(id){
            const width = this.$refs.channel_tab.children[id - 1].clientWidth;
            const left = this.$refs.channel_tab.children[id - 1].getBoundingClientRect().left;
            const tab_left = this.countTabLeft();
            this.updateTabLeft(left - tab_left);
            this.updateTabWidth(width);
        },
        resizeTabHighLighter(id) {
            setTimeout(()=>{
                if(this.$refs.channel_tab.children[id - 1] != undefined) {
                    const width = this.$refs.channel_tab.children[id - 1].clientWidth;
                    const left = this.$refs.channel_tab.children[id - 1].getBoundingClientRect().left;
                    const tab_left = this.countTabLeft();
                    this.updateTabLeft(left - tab_left);
                    this.updateTabWidth(width); 
                }
            }, 100)
            
        },
        setTabHighLighter(id){
            const width = this.$refs.channel_tab.children[id - 1].clientWidth;
            const left = this.$refs.channel_tab.children[id - 1].getBoundingClientRect().left;
            const tab_left = this.countTabLeft();
            this.updateTabLeft(left - tab_left);
            this.updateTabWidth(width);
            this.updateTabId(id);
        },
        setShowAnimation(){
            setTimeout(()=>{
                this.showAnimation = true;
            }, 500)
        },
        setWindowWidth() {
            this.updateWindowWidth(window.innerWidth)
        },
        executeWhenResize(e) {
            this.setWindowWidth();
            this.resizeTabHighLighter(this.tab_id);
        },
        paFunction() {
            window._piq.push(['trackEvent', 'rs2022::十大頻道::' + this.pa_page_name, 'imps::頁面::page::user_action', '', '']);
        },
        paScrollFunction(){
            addEventListener("scroll", () => {
                window._piq.push(['trackEvent', 'rs2022::十大頻道::' + this.pa_page_name, 'scroll::頁面::page::user_action', '', '']);
            }, { once: true });
        },
        addScrollEventListener() {
            window.addEventListener('scroll', this.paScrollFunction, { once: true });
        },
        removeScrollEventListener() {
            window.removeEventListener('scroll', this.paScrollFunction);
        },
        gtag(){
            window.dataLayer.push(arguments);
        },
        activeGaPage() {
            this.gtag('config', 'G-RPGK0ML6QM', {
                'channel_category': '美妝'
            });
            this.gtag('config', 'G-45SMZ66RLZ', {
                'channel_category': '美妝'
            });
            this.gtag('event', 'page_view', {
                page_title: '美妝-PIXNET痞客邦',
            });
        },
        activeMcPage() {
            (function(c,l,a,r,i,t,y){
                c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "kbvat69or6");
        },
    },
    async fetch(){
        const item = { type: 'group', pre_page: 10, id: this.channel_page_id, ver: 2 }
        await this.$store.dispatch("article/getDayHotArticleBeauty", item);
    },
    mounted() {
        window.dataLayer = window.dataLayer || [];
        this.activeGaPage();
        this.activeMcPage();
        this.paFunction();
        this.paScrollFunction();
    }
}
